<template>
  <v-dialog v-model="show" persistent max-width="500">
    <v-card v-if="company">
      <v-card-title class="headline"></v-card-title>
      <v-card-text>Parece que el CIF para esta empresa no está configurado correctamente, </v-card-text>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <strong>Empresa:</strong> 
          </v-col>
          <v-col cols="8">
            {{company.company_name}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
           <strong>CIF actual:</strong> 
          </v-col>
          <v-col cols="8">
           {{company.company_nif}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
           <strong>CIF correcto:</strong> 
          </v-col>
          <v-col cols="5">
            <v-text-field
            regular
             color="primary" 
             dense
             hide-details
             v-model="cif_doc">
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined text class="primary-border" @click="close()">MANTENER CIF ACTUAL</v-btn>
        <v-btn color="white" text class="primary-bckground" @click="fix()">CORREGIR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FixCIFPopup',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    cif_doc: {
      type: String,
      required: false
    },
    company: {
      type: Object,
      required: false
    },
  },
  methods:{
    close(){
      this.$emit("close");
    },
    fix(){
      this.$emit("fix",this.cif_doc);
    }
  }
}
</script>

<style lang="scss" scoped>
  .primary-bckground {
    background-color: #663399;
  }
  .primary-border {
    border-color: #663399 !important;
  }
</style>
